import * as React from "react";

import { Maybe, TagTitle } from "../../../types/thecookies";
import DoNotMountComponent from "../../DoNotMountComponent/DoNotMountComponent";

export const createTitle = (
  title: Maybe<string>,
  type?: TagTitle,
  props?: object,
) => {
  if (!title || title === "null" || title === "undefined")
    return <DoNotMountComponent sms={"falta title"} log={title} />;
  return React.createElement(
    type || "p",
    props ? { ...props } : { className: "a-title" },
    getStringWithBr(title),
  );
};

function getStringWithBr(str: string) {
  const partsString = str.split("\\n");

  const processBoldText = (text: string) => {
    const regex = /\*([^*]+)\*/g;
    const result: JSX.Element[] = [];
    let lastIndex = 0;

    let match;
    while ((match = regex.exec(text)) !== null) {
      // Add the text before the match.
      if (match.index > lastIndex) {
        result.push(
          <span key={lastIndex}>{text.slice(lastIndex, match.index)}</span>,
        );
      }

      // Add the matched text wrapped in <b> tags.
      result.push(<b key={match.index}>{match[1]}</b>);

      lastIndex = regex.lastIndex;
    }

    // Add any remaining text after the last match.
    if (lastIndex < text.length) {
      result.push(<span key={lastIndex}>{text.slice(lastIndex)}</span>);
    }

    return result;
  };

  return partsString.map((item, index) => {
    return (
      <React.Fragment key={index}>
        {processBoldText(item)}
        {index <= partsString.length - 2 && <br />}
      </React.Fragment>
    );
  });
}

export const createTitleWithStyle = (
  index: Maybe<string>,
  title: Maybe<string>,
  type?: TagTitle,
) => {
  const partsString = title?.split(" ");
  let content = "";

  const lastWord = partsString?.[partsString.length - 1] || "";
  const secondLastWord = partsString?.[partsString.length - 2] || "";

  if (lastWord.length < 3 && partsString?.length > 1) {
    // En este caso, concatenar todo excepto las dos últimas palabras
    for (let i = 0; i < partsString.length - 2; i++) {
      const item = partsString[i];
      content += item === "\\n" ? "<br />" : `${item} `;
    }
    // Añadir las dos últimas palabras con la clase 'highlight'
    content += `<span class="highlight"> ${secondLastWord} ${lastWord}</span>`;
  } else {
    // Caso normal: cada palabra en su propio lugar
    for (let i = 0; i < partsString.length - 1; i++) {
      const item = partsString[i];
      content += item === "\\n" ? "<br />" : `${item} `;
    }
    // Envolver solo la última palabra con la clase 'highlight'
    content += `<span class="highlight"> ${lastWord}</span>`;
  }

  return React.createElement(
    type || "p",
    { className: "h2" },
    <>
      {index} <br />
      <span
        className={"subtitle"}
        dangerouslySetInnerHTML={{ __html: content }}
      ></span>
    </>,
  );
};

export function textWithLastWordHighlight(str: string, className?: string) {
  const partsString = str.split(" ");
  let content = "";

  const lastWord = partsString[partsString.length - 1];
  const secondLastWord = partsString[partsString.length - 2];

  if (lastWord.length < 3) {
    // En este caso, concatenar todo excepto las dos últimas palabras
    for (let i = 0; i < partsString.length - 2; i++) {
      const item = partsString[i];
      content += item === "\\n" ? "<br />" : `${item} `;
    }
    // Añadir las dos últimas palabras con la clase 'highlight'
    content += `<span class="highlight"> ${secondLastWord} ${lastWord}</span>`;
  } else {
    // Caso normal: cada palabra en su propio lugar
    for (let i = 0; i < partsString.length - 1; i++) {
      const item = partsString[i];
      content += item === "\\n" ? "<br />" : `${item} `;
    }
    // Envolver solo la última palabra con la clase 'highlight'
    content += `<span class="highlight"> ${lastWord}</span>`;
  }

  return React.createElement("p", {
    className: className || "",
    dangerouslySetInnerHTML: { __html: content },
  });
}
